import { Box } from '@mui/material';
import { Fragment } from 'react';
import InlineEditDisplay from '../InlineEditDisplay/InlineEditDisplay';
import Select from '../Select/Select';
import { useInlineEditSelect } from './hooks/useInlineEditSelect';
import { InlineEditSelectProps } from './inlineEditSelect.types';

const InlineEditSelect = (props: InlineEditSelectProps) => {
  const { options, isDisabled, isMuted, hasError, errorMessage, placeholder, testId } = props;
  const isInvalid = hasError || !!errorMessage;
  const { isEditing, draftValues, selectedOptions, handleStartEditing, handleChange, handleClose } =
    useInlineEditSelect(props);

  if (!isEditing) {
    return (
      <InlineEditDisplay
        isEmpty={selectedOptions.length === 0}
        isDisabled={Boolean(isDisabled)}
        isMuted={isMuted}
        hasError={hasError}
        errorMessage={errorMessage}
        placeholder={placeholder}
        testId={testId}
        onStartEditing={handleStartEditing}
      >
        {selectedOptions.map((option, index) => (
          <Fragment key={option.value}>
            {index > 0 && ', '}
            {option.label}
          </Fragment>
        ))}
      </InlineEditDisplay>
    );
  }

  return (
    <Box
      sx={(theme) => ({
        '& .MuiOutlinedInput-root': {
          ...theme.typography.body2,
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.action.selected,
          borderRadius: `${theme.shape.borderRadiusMd}px`,
        },
        '& .MuiSelect-select.MuiInputBase-inputSizeSmall': {
          padding: theme.spacing(0.5, 0.75),
          minHeight: 'auto',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      })}
    >
      <Select
        open
        autoFocus
        size="small"
        multiple={props.multiple}
        value={props.multiple ? draftValues : (props.value ?? '')}
        options={options}
        disabled={isDisabled}
        error={isInvalid}
        testId={testId}
        onChange={handleChange}
        onClose={handleClose}
      />
    </Box>
  );
};

export default InlineEditSelect;
